const MISSING_KEY_PREFIX = '🔴 MISSING TRANSLATION: ';

const shouldMarkMissingKeys = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.endsWith('localhost');
};

export const markMissingTranslations = <T extends Record<string, string>>(translations: T): T => {
  if (!shouldMarkMissingKeys()) return translations;
  return new Proxy(translations, {
    get(target, prop, receiver) {
      if (typeof prop !== 'string' || prop in target) {
        return Reflect.get(target, prop, receiver);
      }
      return `${MISSING_KEY_PREFIX}${prop}`;
    },
  });
};
